import { useState } from 'react'
import { getFormattedCityNames, getFormattedCountryName } from '~/lib/helpers/constants'
import AddListingTwoStepDrawer from '../Drawers/AddListingTwoStepDrawer'
import { OhButton } from '~/components/ui/custom-radix-components/button'

export default function PartnerWithOfficeHubMobile({ region, className }: { region?: string, className?: string }) {
  const [addListingModal, setAddListingModal] = useState(false)
  return (
    <div className={`p-4 flex flex-col gap-2 ${className}`}>
      {addListingModal && (
        <AddListingTwoStepDrawer onClose={() => setAddListingModal(false)} />
      )}
      <h2 className="uppercase font-semibold text-xs text-gray-500 tracking-widest">Why List with Office Hub {getFormattedCountryName(region)}</h2>
      <p className="text-2xl font-semibold text-gray-900">Join the world's leading marketplace for flexible offices.
      </p>
      <p className="text-gray-600 text-sm">
        Office Hub {getFormattedCountryName(region)} connects coworking, serviced, and private office providers with thousands of verified tenants actively searching for workspace across {getFormattedCityNames(region)} and beyond.
      </p>
      <div className="rounded-xl overflow-hidden w-full aspect-[4/3] bg-gray-200 mb-2">
        <img
          src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/partners.avif`}
          alt="Office Hub team collaboration and workspace environments"
          width={400}
          height={300}
          loading="lazy"
          decoding="async"
          className="w-full  object-cover"
        />
      </div>
      <ul className="mb-2 text-gray-700 text-sm flex flex-col gap-2">
        <li>
          <h3 className="font-semibold">Free to List</h3>
          <p>Showcase your spaces at no cost. You only pay when a deal closes.</p>
        </li>
        <li>
          <h3 className="font-semibold">Qualified Leads</h3>
          <p>Every enquiry is verified by our workspace experts.</p>
        </li>
        <li>
          <h3 className="font-semibold">Analytics & Insights</h3>
          <p>Get data on views, engagement, and conversion rates.</p>
        </li>
        <li>
          <h3 className="font-semibold">Dedicated Support</h3>
          <p>Our team books your tours, qualifies prospects, and helps finalize deals.</p>
        </li>
        <li>
          <h3 className="font-semibold">Global Exposure</h3>
          <p>Your listings appear on Office Hub's international network across 110+ countries.</p>
        </li>
      </ul>

      <OhButton onClick={() => setAddListingModal(true)} className="font-medium py-2 px-6 rounded-md w-full mt-2">
        Add Listing
      </OhButton>
    </div >
  )
}
